import { NgModule } from '@angular/core';
import { ImageOrientationDirective } from './image-orientation.directive';

@NgModule({
  declarations: [
    ImageOrientationDirective
  ],
  exports: [
    ImageOrientationDirective
  ]
})
export class ImageOrientationModule {}
